import React, { useEffect, useState } from 'react'
import { getColorCode } from '../../utils/helper'
import { Box } from '@mui/material'
import { Add, SearchStatus } from 'iconsax-react'

interface SearchInputProps {
  placeholder: string
  value: string
  setSearchTerm?: any
  isSelectSearch?: boolean
  onChange: (event: React.ChangeEvent<HTMLInputElement>) => void
  onSearch?: (term?: string) => void
}

const SearchInput: React.FC<SearchInputProps> = ({
  placeholder,
  value,
  onChange,
  setSearchTerm,
  onSearch,
  isSelectSearch
}) => {
  const [showCloseIcon, setShowCloseIcon] = useState<boolean>(!!value)

  const handleKeyDown = (event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event?.preventDefault()
      onSearch?.()
      if (value?.trim()?.replace(/\s+/g, ' ') === '') {
        setShowCloseIcon(false)
      } else {
        setShowCloseIcon(true)
      }
    }
  }
  const handleSearchClick = () => {
    onSearch?.()
    setShowCloseIcon(true)
  }

  useEffect(() => {
    if (!isSelectSearch) {
      if (value?.trim()?.replace(/\s+/g, ' ') === '') {
        setShowCloseIcon(false)
      } else {
        setShowCloseIcon(true)
      }
    }
  }, [value, isSelectSearch])

  return (
    <Box
      display={'flex'}
      alignItems={'center'}
      border={`1px solid ${getColorCode('purpleBlue')}`}
      borderRadius={'10px'}
      padding={'10px 10px 10px 15px'}
      height={40}
      gap={1}
      flexDirection={'row-reverse'}
    >
      {showCloseIcon ? (
        <Add
          color={getColorCode('purpleBlue')}
          onClick={() => {
            setSearchTerm('')
            setShowCloseIcon(false)
            onSearch?.('')
          }}
          style={{ transform: 'rotate(45deg)' }}
          className='cursor-pointer'
        />
      ) : (
        <SearchStatus
          color={getColorCode('purpleBlue')}
          className='cursor-pointer'
          onClick={() => value?.trim()?.replace(/\s+/g, ' ') !== '' && handleSearchClick()}
        />
      )}
      <input
        type='text'
        value={value}
        onChange={onChange}
        placeholder={placeholder}
        onKeyDown={handleKeyDown}
        className='bg-transparent min-w-[205px]'
      />
    </Box>
  )
}

export default SearchInput
